import fetch from 'isomorphic-fetch';

export const updateToken = (token, email = '') => dispatch => {
  dispatch({
    type: 'UPDATE_TOKEN',
    payload: { token, email }
  });
};

export const updateTokenVerificationError = message => dispatch => {
  dispatch({
    type: 'UPDATE_TOKEN_VERIFICATION_ERROR',
    message
  });
};

export const tokenVerification = token => dispatch => {
  fetch('/auth/reset-password/verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      data: {
        attributes: {
          token
        }
      }
    })
  }).then(res => {
    if (res.ok) {
      if (res.redirected) {
        window.location = res.url;
      }

      return res.json().then(data => {
        dispatch(updateToken(token, data.email));
        dispatch(updateTokenVerificationError(null));
      });
    }
    return res.json().then(data => {
      dispatch(updateTokenVerificationError(data.error));
    });
  });
};

const getLang = () => navigator.language.substr(0, 2).toLowerCase();

export const resetPassword = email => () =>
  fetch('/auth/reset-password', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      data: {
        attributes: {
          email,
          lang: getLang()
        }
      }
    })
  });

export const resetPasswordPerform = (token, password) => () =>
  fetch('/auth/reset-password/perform', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      data: {
        attributes: {
          token,
          password,
          lang: getLang()
        }
      }
    })
  });



// WEBPACK FOOTER //
// ./action-creators/resetPassword.js